export default "__VITE_ASSET__DjQ4FJRt__"